import { NEXT_STEP, PREVIOUS_STEP, SET_STEPS } from './actions'
import { OnboardingActionType,
  OnboardingSteps,
  OnboardingStore } from './types'

const initalState: OnboardingStore = {
  step: OnboardingSteps.AGENDAS,
  index: 0,
  steps: [
    OnboardingSteps.AGENDAS,
    OnboardingSteps.CONNECTED,
    OnboardingSteps.NAME,
    OnboardingSteps.LOCATION,
    OnboardingSteps.RANGES,
    OnboardingSteps.COMPLETED,
    OnboardingSteps.COMPANY,
  ],
}

export const reducer = (state = initalState, action: OnboardingActionType): OnboardingStore => {
  switch (action.type) {
    case NEXT_STEP:
      if (state.index < state.steps.length - 1) {
        return {
          ...state,
          step: state.steps[state.index + 1],
          index: state.index + 1,
        }
      } else {
        return state
      }

    case PREVIOUS_STEP:
      if (state.index > 0) {
        return {
          ...state,
          step: state.steps[state.index - 1],
          index: state.index - 1,
        }
      } else {
        return state
      }

    case SET_STEPS:
      return {
        ...state,
        steps: action.steps,
        step: action.steps[0],
      }

    default:
      return state
  }
}
